import { useProfiles } from "@/context/ProfileContext";
import { ProfileSelect } from "@/components/ProfileSelect";

export function ProfileGate({ children }) {
  const ctx = useProfiles();
  if (!ctx || ctx.loading) {
    return (
      <div className="min-h-screen starfield flex items-center justify-center">
        <p className="font-display italic text-2xl text-foreground/50">L'Élan s'éveille…</p>
      </div>
    );
  }
  if (!ctx.activeProfile) return <ProfileSelect />;
  return children;
}
